module.exports = __webpack_public_path__ + "static/lifetime-fitness-platinum-membership-icon-27b6a14da450310aafc39f88848b35de.svg";